import { useState } from "react"
import { useDispatch } from "react-redux"
import Button from "react-bootstrap/Button"
import { message } from "state_management"
import { Title, Number, Container, Text, Select } from "components/Form"
import { Popup } from "components"
import useT from "utils/hooks/useT"

import "./index.scss"
import { DateTime } from "luxon"

// Is used to create recurrences in green/whitetasks
export default function RecurrenceConfig({ onClose, task, onSubmit, recurrenceSettings }) {
  const { t } = useT("common")
  const { t: tm } = useT("messages")
  const [amount, setAmount] = useState(recurrenceSettings.amount)
  const [interval, setInterval] = useState(recurrenceSettings.interval)
  const [recurrence, setRecurrence] = useState([recurrenceSettings.recurrence])
  const formatedStartDate = task.recurrenceStart
    ? DateTime.fromISO(task.recurrenceStart).toFormat("yyyy-MM-dd HH:mm")
    : DateTime.fromISO(task.start).toFormat("yyyy-MM-dd HH:mm")
  const recurrenceList = [
    { name: t("daily"), id: "DAILY" },
    { name: t("weekly"), id: "WEEKLY" },
  ]
  const recurrencePlaceholder = recurrence[0] === "DAILY" ? t("days") : recurrence[0] === "WEEKLY" ? t("weeks") : ""

  const dispatch = useDispatch()
  function validateRecurrenceFields() {
    if (task.recurrenceId) {
      return ""
    } else {
      if (!amount && !interval) {
        return "pleaseFillNumberAndInterval"
      } else if (!amount) {
        return "pleaseFillNumberOfRecurrences"
      } else if (!interval) {
        return "pleaseFillIntervalOfRecurrences"
      } else if (amount > 365) {
        return "recurrencesCannotExceed365"
      }
      return ""
    }
  }
  return (
    <div className="RecurrenceConfig-container">
      <Popup className="RecurrenceConfig-Popup" onCancel={onClose}>
        <h3>{t("recurrence")}</h3>
        <Container>
          <Title>{t("startRecurrence")}</Title>
          <div className="RecurrenceConfig-startDate">
            <Text disabled placeholder={formatedStartDate}></Text>
          </div>
        </Container>
        <Container>
          <Title>{t("recur")}</Title>
          <div className="RecurrenceConfig-select">
            <Select
              collection={recurrenceList}
              value={recurrence}
              onChange={setRecurrence}
              isMulti={false}
            ></Select>
          </div>
        </Container>
        <Container>
          <Title>{t("recurEvery")}</Title>
          <div className="Recurrence-number">
            <Number value={interval} onChange={setInterval} min={0} />
          </div>
          <Title>{recurrencePlaceholder}</Title>
        </Container>
        <Container>
          <Title>{t("numberOfRecurrences")} </Title>
          <div className="Recurrence-number">
            <Number value={amount} onChange={setAmount} min={0} />
          </div>
          <Title>{recurrencePlaceholder}</Title>
        </Container>
        <div className="RecurrenceConfig-buttons">
          <Button variant="secondary" onClick={onClose}>
            {t("cancel")}
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              const msg = validateRecurrenceFields()
              if (msg) {
                dispatch(message.warning(tm(msg)))
                return
              }

              onSubmit({
                recurrence: recurrence[0],
                amount: interval ? amount : 0,
                interval: interval ? interval : 1,
              })

              onClose()
            }}
          >
            {t("save")}
          </Button>
        </div>
      </Popup>
    </div>
  )
}
